/* eslint-disable no-param-reassign */
import { PushApi } from 'client/api/v2/PushMfaApi';
import { cloneDeep, isEqual } from 'lodash';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import PushMessages from 'client/MFA/push/PushMessages.json';
import Vue from 'vue';

export const INITIALIZE_STATE = 'INITIALIZE_STATE';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_ERROR_SAVING = 'SET_ERROR_SAVING';
export const SET_STARTING_STATE = 'SET_STARTING_STATE';
export const SET_STATE = 'SET_STATE';

const initialState = () => ({
  errorSaving: false,
  config: {
    enabled: undefined,
  },
});

export const createPushMfaUserPortalModule = api => ({
  namespaced: true,

  state: {
    ...initialState(),
    startingState: { ...initialState() },
  },

  actions: {
    changeConfig({ commit }, payload) {
      commit(SET_CONFIG, payload);
    },
    async initialize({ commit }) {
      commit(INITIALIZE_STATE);

      try {
        const config = await api.getUserPortalConfig();
        commit(SET_CONFIG, config);
        commit(SET_STARTING_STATE);
      } catch (exp) {
        /* NOOP: enabled will be undefined which is a valid value */
      }
    },

    resetState({ commit }) {
      commit(SET_STATE);
    },
    async saveChanges({
      commit, state, dispatch, getters,
    }) {
      if (getters.hasChanges) {
        try {
          const result = await api.updateUserPortalConfig({ ...state.config });
          commit(SET_CONFIG, result.data);
          commit(SET_ERROR_SAVING, false);
          commit(SET_STARTING_STATE);
          // Notify Success
          const status = state.config.enabled ? 'enabled' : 'disabled';

          dispatch(`${notificationModule}/triggerSuccessNotification`, {
            title: `JumpCloud Protect Mobile Push has been ${status}.`,
          }, { root: true });
        } catch {
          commit(SET_ERROR_SAVING, true);
          // Notify Error
          const errorMessage = PushMessages.SaveError;

          dispatch(`${notificationModule}/triggerErrorNotification`, {
            title: errorMessage,
          }, { root: true });
          throw new Error(errorMessage);
        }
      }
    },
  },

  getters: {
    enabled(state = {}) {
      return state.config.enabled;
    },
    hasChanges(state = {}) {
      return !isEqual(state.config, state.startingState.config);
    },
    hasErrors(state = {}) {
      return state.errorSaving;
    },
  },

  mutations: {
    [INITIALIZE_STATE]: (state) => {
      const { config, errorSaving } = initialState();
      Vue.set(state, 'config', config);
      Vue.set(state, 'errorSaving', errorSaving);
      Vue.set(state, 'startingState', initialState());
    },
    [SET_CONFIG]: (state, config = {}) => {
      Vue.set(state.config, 'enabled', config.enabled);
    },
    [SET_ERROR_SAVING]: (state, error = false) => {
      Vue.set(state, 'errorSaving', error);
    },
    [SET_STATE]: (state) => {
      Vue.set(state, 'config', cloneDeep(state.startingState.config));
      Vue.set(state, 'errorSaving', initialState().errorSaving);
    },
    [SET_STARTING_STATE]: (state) => {
      Vue.set(state.startingState, 'config', cloneDeep(state.config));
    },
  },
});

export default createPushMfaUserPortalModule(new PushApi());
